// A valid zip code consists of 5 digits
const validateZip = value => /^[0-9]{5}$/.test( value );

export default validateZip;
